import { render, staticRenderFns } from "./TabContractDetails.vue?vue&type=template&id=1152cc1d&scoped=true"
import script from "./TabContractDetails.vue?vue&type=script&lang=js"
export * from "./TabContractDetails.vue?vue&type=script&lang=js"
import style0 from "./TabContractDetails.vue?vue&type=style&index=0&id=1152cc1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152cc1d",
  null
  
)

export default component.exports